import { useHealth } from "./useHealth";
import { RailLogo } from "@/shared/ui/RailLogo";

export function HealthPage() {
  const { data, error } = useHealth();
  return (
    <main className="min-h-screen flex items-center justify-center bg-paper text-ink">
      <div className="max-w-md w-full p-8 rounded-lg border border-line bg-card text-center">
        <div className="flex justify-center mb-4">
          <RailLogo size={56} />
        </div>
        <h1 className="font-display text-2xl font-bold mb-2">Order Manager</h1>
        {error && <p className="text-red">{error}</p>}
        {data && (
          <p className="text-sm text-ink-3">
            {data.status === "ok"
              ? "Backend attivo e raggiungibile."
              : `Backend in stato «${data.status}».`}{" "}
            <span className="font-mono text-ink">v{data.version}</span>
          </p>
        )}
        {!data && !error && <p className="text-ink-3">Verifico il backend…</p>}
      </div>
    </main>
  );
}
